import { Star } from 'lucide-react';

/**
 * Compact seller rating badge — displays average stars + count.
 * `size`: "sm" (default, for cards) | "md" (for detail pages) | "lg" (for profile header)
 */
export default function SellerRatingBadge({ avg = 0, count = 0, size = 'sm', showCount = true, className = '' }) {
	const rounded = Math.round((avg || 0) * 10) / 10;
	const sizes = {
		sm: { icon: 'w-3 h-3', text: 'text-xs' },
		md: { icon: 'w-4 h-4', text: 'text-sm' },
		lg: { icon: 'w-5 h-5', text: 'text-base' },
	};
	const s = sizes[size] || sizes.sm;

	if (!count) {
		return (
			<span
				className={`inline-flex items-center gap-1 text-[#9C8E70] ${s.text} ${className}`}
				data-testid="seller-rating-empty"
			>
        <Star className={s.icon} />
        <span className="opacity-70">—</span>
      </span>
		);
	}

	return (
		<span
			className={`inline-flex items-center gap-1 text-[#8B4513] font-medium ${s.text} ${className}`}
			data-testid="seller-rating-badge"
		>
      <Star className={`${s.icon} fill-[#D4AF37] text-[#D4AF37]`} />
      <span className="text-[#1A3C34] font-semibold">{rounded.toFixed(1)}</span>
			{showCount && <span className="text-[#666055] font-normal">({count})</span>}
    </span>
	);
}